import PaginatedTable from "../../actprep-ui/components/PaginatedTable";
import { apiUrls } from "../../actprep-ui/utils/urls";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

export default function StudentTableDialog({
  filterParams,
  title,
  ...useDisclosureProps
} = {}) {
  const columns = [
    { field: "first_name", headerName: "First Name", width: 150 },
    { field: "last_name", headerName: "Last Name", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
  ];
  const { isOpen, getDisclosureProps } = useDisclosureProps;
  return (
    <Dialog
      {...getDisclosureProps({
        slotProps: {
          paper: {
          sx: {
            height: "100vh",
          },
        }
        },
        maxWidth: "xl",
      })}
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <PaginatedTable
          enabled={isOpen}
          apiUrl={apiUrls.admin.studentProfiles()}
          urlParams={filterParams}
          columns={columns}
          searchable
        />
      </DialogContent>
    </Dialog>
  );
}
